import { useQuery } from '@tanstack/react-query';
import { UserRound } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useApi } from '../api/api-context';

export function AccountMenu(): JSX.Element {
  const api = useApi();
  const { data } = useQuery({ queryKey: ['profile'], queryFn: () => api.getProfile() });
  return (
    <NavLink to="/profile" className="account-menu" aria-label="Profile settings">
      <UserRound size={16} />
      <span>{data?.username ? `@${data.username}` : 'Profile'}</span>
    </NavLink>
  );
}
